import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {runAfterLoadSession} from "../../utils/Utility";
import Loading from "../shared/Loading";
import {addCategory, getCategories, getCategoryList, getFields, removeCategory} from "../../utils/API";
import HeaderApp from "../home/HeaderApp";

class CategoryList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            fields: [],

        }
    }

    componentDidMount() {
        runAfterLoadSession(() => {
            getCategoryList((res) => {
                this.setState({categories: res})
            })
            getFields((res) => {
                this.setState({
                    fields: res,
                })
            })
        })

    }

    haveCategory = (categoryHashId) => {
        return this.state.categories.filter(c => c.hashId === categoryHashId).length > 0
    }

    addOrRemoveCategory = (categoryHashId) => {
        if (this.haveCategory(categoryHashId)) {
            removeCategory(categoryHashId, (res) => this.setState({categories: res}))
        } else
            addCategory(categoryHashId, (res) => this.setState({categories: res}))
    }

    showCategories = (field) => {
        this.setState({
            ['showCategory' + field.hashId]: (this.state['showCategory' + field.hashId] === undefined ? true : !this.state['showCategory' + field.hashId])
        })
        if (!this.state['category' + field.hashId]) {
            getCategories(field.hashId, (res) => {
                this.setState({
                    ['category' + field.hashId]: res,
                })
            })
        }
    }

    render() {
        return (
            <div className="">
                <HeaderApp name="Categories" back="/hom"/>
                <div className="main-app">
                    <div>
                        <div className="mt-3 body-app">
                            <div>
                                {this.state.categories.length === 0 &&
                                <span className="d-block text-center mb-4">There are no categories selected</span>}
                                {
                                    this.state.categories.map((c) =>
                                        <div key={c.hashId} className="category-item shadow-black mb-2 p-3">
                                            <img alt="" src={window.baseFile + c.logoUrl}/>
                                            <span className="ml-3">{c.name}</span>
                                            <button className="waves-effect waves-light btn red no-uppercase" onClick={() => this.addOrRemoveCategory(c.hashId)}>
                                                <span>remove</span>
                                            </button>
                                        </div>)
                                }
                                <h5 className="d-block text-center mt-5 mb-2">you can choose categories from the list:</h5>
                                {
                                    this.state.fields.map((field) => <div key={field.hashId}
                                                                          className="shadow-black mb-3 p-2">
                                        <button className="category-item"
                                                onClick={() => this.showCategories(field)}>
                                            <img alt="" src={window.baseFile + field.logoUrl}/>
                                            <span className="ml-3">{field.name}</span>
                                            <i className={"icon-arrow_back_ios " + (this.state['showCategory' + field.hashId] ? "show-cat" : "")}/>
                                        </button>
                                        {this.state['showCategory' + field.hashId] && <div style={{minHeight: '20px'}}>
                                            <Loading show={this.state['category' + field.hashId] === undefined}
                                                     colorful>
                                                <div className="category-border mt-3 ">
                                                {
                                                    this.state['category' + field.hashId] ? (this.state['category' + field.hashId].map(c =>
                                                        <div
                                                            className="category-item pt-3" key={c.hashId}>
                                                            <img alt="" src={window.baseFile + c.logoUrl}/>
                                                            <span className="ml-3">{c.name}</span>
                                                            <button onClick={() => this.addOrRemoveCategory(c.hashId)}
                                                                    className={"waves-effect waves-light btn no-uppercase " + (this.haveCategory(c.hashId) ? 'green' : 'white')}>
                                                                <span className={this.haveCategory(c.hashId) ? "" : "black-text"}>{this.haveCategory(c.hashId) ? 'Added' : 'Add'}</span>
                                                            </button>
                                                        </div>)) : (<span/>)
                                                }
                                                </div>
                                            </Loading>
                                        </div>}

                                    </div>)
                                }
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        tutorEnv: state.param[Objects.tutorEnv],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryList)
